module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup xfind"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "twui-signup-body",
    style: ({
      'min-height': _vm.minHeight
    })
  }, [_c('h2', [_vm._v("找回密码")]), _vm._v(" "), _c('div', {
    staticClass: "twui-steps xfind"
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.active
    }
  }, [_c('el-step', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "title": "填写帐户名"
    }
  }), _vm._v(" "), _c('el-step', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "title": "验证身份"
    }
  }), _vm._v(" "), _c('el-step', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "title": "设置新密码"
    }
  }), _vm._v(" "), _c('el-step', {
    attrs: {
      "title": "完成"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 1),
      expression: "active==1"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("填写帐户名")]), _vm._v(" "), _c('el-form', {
    staticClass: "twui-findpwd"
  }, [_c('el-form-item', {
    attrs: {
      "label": "帐户名:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验证码:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "30px"
    },
    attrs: {
      "src": "/static/dev/images/code.png"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请选择验证身份方式:",
      "label-width": "11em"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "phone"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("手机验证")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "email"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("邮箱验证")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 2),
      expression: "active==2"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("验证身份")]), _vm._v(" "), (_vm.type === 'phone') ? _c('el-form', {
    staticClass: "twui-findpwd"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "label-width": "11em"
    }
  }, [_vm._v("用户姓名")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "已验证手机:",
      "label-width": "11em"
    }
  }, [_vm._v("137****143")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请填写手机验证码:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'email') ? _c('el-form', {
    staticClass: "twui-findpwd"
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名:",
      "label-width": "11em"
    }
  }, [_vm._v("用户姓名")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱:",
      "label-width": "11em"
    }
  }, [_vm._v("137****143")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请填写邮箱验证码:",
      "label-width": "11em"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "160px"
    },
    attrs: {
      "auto-complete": "off"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "twui-xlink"
  }, [_vm._v("  获取验证码")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 3),
      expression: "active==3"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("设置新密码")]), _vm._v(" "), _c('el-form', {
    staticClass: "twui-findpwd",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新登录密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认新密码:",
      "label-width": "7em"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active == 4),
      expression: "active==4"
    }]
  }, [_c('div', {
    staticClass: "twui-blocktitle"
  }, [_vm._v("完成")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "text-align": "left"
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v("请牢记您新设置的密码,"), _c('router-link', {
    staticClass: "twui-xlink",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("返回首页")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "twui-btnarea"
  }, [_c('div', {
    staticClass: "twui-btnarea-inner"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active < 3),
      expression: "active<3"
    }],
    staticClass: "twui-btn xmain xlarge xdisabled",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active === 3),
      expression: "active===3"
    }],
    staticClass: "twui-btn xmain xlarge",
    on: {
      "click": _vm.next
    }
  }, [_vm._v("提交")])])])]), _vm._v(" "), _c('tw-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "twui-signup-header"
  }, [_c('img', {
    attrs: {
      "src": "static/dev/images/logo_reg.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "twui-xhighlight3"
  }, [_c('i', {
    staticClass: "el-icon-check"
  }), _vm._v("  新密码设置成功!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-a51d2a52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/web/find_password.vue
// module id = 600
// module chunks = 1